<template>
  <!-- <div id="app" :key="appKey" > -->
  <div id="app-main" :key="appKey" class="app-main">
    <router-view v-if="isRouterAlive" />
  </div>
</template>

<script>
  export default {
    name: 'app-main',
    provide() {
    return {
      reload: this.reload,
    };
  },
    data(){
        return{
            appKey:1,
            isRouterAlive: true,
        }
    },
    watch:{
        '$route'(to, from){
            this.appKey = new Date().getTime();
        }
    },
    created(){
      // if(localStorage.getItem('orgId') == '3883'){
      //   document.title="江汉区图书馆";
      // }else{
      //   if(this.$route.name != 'Login'){
      //     document.title="田田阅读网";
      //   }else{
      //     document.title="登录";
      //   } 
      // }
    },
    methods: {
        // reload() {
        //     this.isRouterAlive = false;
        //     this.$nextTick(function () {
        //       this.isRouterAlive = true;
        //     });
        // },
    },
  }
</script>

<style lang="scss">
    @import '~@/style/common.scss'
</style>



// WEBPACK FOOTER //
// src/App.vue